exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".graphic-imob-container[data-v-51716fc0]{max-height:250;overflow-y:auto;overflow-x:hidden}", "", {"version":3,"sources":["/var/www/corretores.idealizacidades.com.br/source/src/components/dashboards/RealStates.vue"],"names":[],"mappings":"AACA,yCACE,eAAgB,AAChB,gBAAiB,AACjB,iBAAmB,CACpB","file":"RealStates.vue","sourcesContent":["\n.graphic-imob-container[data-v-51716fc0] {\n  max-height: 250;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-51716fc0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboards/RealStates.vue
// module id = 497
// module chunks = 3